const generateNavItems = (data) => {
	//TODO: Using old mongodb names for fields, but we probably want to make menu dynamic anyway
	const result = []
	data.forEach((schoolType, indexST) => {
		result.push({ title: schoolType.title, data: [] })
		if (schoolType.subjects.length === 0) return (result[indexST].to = `/${schoolType._id}`)
		schoolType.subjects.forEach((subject, indexSUB) => {
			result[indexST].data.push({
				label: subject.title,
				content: []
			});
			if (subject.courses.length === 0)
				return (result[indexST].data[indexSUB].to = `/${schoolType._id}/${subject.param}`)
			subject.courses.forEach((course, indexC) => {
				result[indexST].data[indexSUB].content.push({
					label: course.title,
					content: []
				});
				if (course.courseContent.length === 0)
					return (result[indexST].data[indexSUB].content[indexC].to = `/${schoolType._id}/${course.param}`)
				course.courseContent.forEach((courseContent, indexCC) => {
					result[indexST].data[indexSUB].content[indexC].content.push({
						label: courseContent.title,
						to: `/${schoolType.param}/${subject.param}/${course.param}/${courseContent.param}/${courseContent._id}`
					})
				})
			})
		})
	})
	return result
};

export default generateNavItems
